import '../css/app.css';
import Alpine from 'alpinejs';
// Alpine plugins
import AlpineAjax from '@imacrayon/alpine-ajax';
import focus from '@alpinejs/focus';

// Alpine components
import AlpineCombobox from './components/combobox';
import AlpineMuliSelect from './components/multiselect';
import AlpineMuliSelectAdd from './components/multiselect_add';
import AlpineExampleEditor from './components/editor/example_editor';
import AlpineRemarkEditor from './components/editor/editor_component_remark';
import AlpineRemarkViewer from './components/editor/viewer_component_remark';

// Make Alpine available globally
window.Alpine = Alpine;

// Register plugins
Alpine.plugin(AlpineAjax);
Alpine.plugin(focus);

// Register components before starting Alpine
AlpineCombobox();
AlpineMuliSelect();
AlpineMuliSelectAdd();
AlpineExampleEditor();
AlpineRemarkEditor();
AlpineRemarkViewer();

// Alpine Magic
Alpine.magic('clipboard', () => async (text) => {
  try {
    // Check if clipboard API is supported
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return { success: true };
    } else {
      // Fallback for older browsers or non-secure contexts
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        document.body.removeChild(textArea);
        return { success: true };
      } catch (fallbackError) {
        document.body.removeChild(textArea);
        throw new Error('Copy failed: ' + fallbackError.message);
      }
    }
  } catch (error) {
    console.error('Clipboard copy failed:', error);
    return { success: false, error: error.message };
  }
});

// Ensure Alpine starts after DOM is ready and prevent FOUC
document.addEventListener('DOMContentLoaded', function () {
  // Start Alpine after all components are registered
  Alpine.start();
});

/*
    If you imported Alpine into a bundle, you have to make sure you are registering any extension
    code IN BETWEEN when you import the Alpine global object, and when you initialize Alpine by
    calling Alpine.start().
*/
